$(".nav-toggle").click(function (e) {
    if (!$("html").hasClass("nav-open")) {
        $("html").addClass("nav-before-open");
        setTimeout(function () {
            $("html").addClass("nav-open");
        }, 300);
    } else {
        $("html").removeClass("nav-open");
        setTimeout(function () {
            $("html").removeClass("nav-before-open");
        }, 300);
    }
});

$(
    ".navigation.custommenu li.ui-menu-item.level0 > .open-children-toggle"
).click(function () {
    if (!$(this).parent().children(".submenu").hasClass("opened")) {
        $(this).parent().children(".submenu").addClass("opened");
        $(this).parent().children("a").addClass("ui-state-active");
    } else {
        $(this).parent().children(".submenu").removeClass("opened");
        $(this).parent().children("a").removeClass("ui-state-active");
    }
});

$(
    ".navigation.custommenu .submenu li.ui-menu-item > .open-children-toggle"
).click(function () {
    if (!$(this).parent().children("ul").hasClass("opened")) {
        $(this).parent().children("ul").addClass("opened");
        $(this).parent().children("a").addClass("ui-state-active");
    } else {
        $(this).parent().children("ul").removeClass("opened");
        $(this).parent().children("a").removeClass("ui-state-active");
    }
});
$(".header-top-setting a.actions-top").click(function () {
    if ($(".header-top-setting .setting-container").hasClass("act-menu-bar")) {
        $(".header-top-setting .setting-container").removeClass("act-menu-bar");
        $(".header-top-setting").removeClass("activedmenubar");
    } else {
        $(".header-top-setting .setting-container").addClass("act-menu-bar");
        $(".header-top-setting").addClass("activedmenubar");
    }
    return false;
});
$("#btn-h-t-s-close").click(function () {
    $(".header-top-setting .setting-container").removeClass("act-menu-bar");
    $(".header-top-setting").removeClass("activedmenubar");
    return false;
});
$("#close-menu a").click(function () {
    $("html").removeClass("nav-open");

    $("html").removeClass("nav-before-open");
    return false;
});
$(".quick-view-content .detailed div.title a").click(function () {
    var id_show = $(this).attr("href");
    $(".quick-view-content .detailed .data.content").hide();
    $(id_show).show();
    return false;
});
$("#back-top").click(function () {
    $("body,html").animate({ scrollTop: 0 }, 800);
    return false;
});
$(".click-show-menu").click(function () {
    if (!$(".click-open").hasClass("show-menu")) {
        $(".click-open").addClass("show-menu");
        $(".click-show-menu")
            .children("i")
            .removeClass("icon-align-right")
            .addClass("icon-x");
    } else {
        $(".click-open").removeClass("show-menu");
        $(".click-show-menu")
            .children("i")
            .removeClass("icon-x")
            .addClass("icon-align-right");
    }
    return false;
});

// footer script
$(document).on("click", ".footer-links .title.mobile", function (event) {
    if ($(this).hasClass("clicked")) {
        $(this).next().slideToggle();
        $(this).toggleClass("clicked");
        $(this).addClass("customer_clicked");
    } else {
        $(".footer-links .title.mobile.clicked").each(function () {
            $(this).next().slideToggle();
            $(this).toggleClass("clicked");
            $(this).removeClass("customer_clicked");
        });

        $(this).next().slideToggle();
        $(this).toggleClass("clicked");
        $(this).addClass("customer_clicked");
    }
});

if ($(window).width() < 768) {
    $(".footer-links .title").addClass("mobile");
    $(".footer-links .title").next().hide();
}

if ($(window).width() < 767) {
    $(".footer-links-list .col-3 h4").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).next(".page-footer .footer.content .links").slideUp(200);
        } else {
            $(".footer-links-list .col-3 h4").removeClass("active");
            $(this).addClass("active");
            $(".page-footer .footer.content .links").slideUp(200);
            $(this).next(".page-footer .footer.content .links").slideDown(200);
        }
    });
}
//   footer help slideToggle
$(document).ready(function () {
    $("#help").click(function () {
        $(".help-sub").slideToggle("slow");
        $("body").toggleClass("stopscroll");
        $(".overlay-help").toggleClass("show");
        if ($(this).text() == "Help?") {
            $(this).text("x");
        } else {
            $(this).text("Help?");
        }
    });

    $(".overlay-help").click(function (e) {
        $(".help-sub").slideToggle("slow");
        $("body").removeClass("stopscroll");
        $(".overlay-help").removeClass("show");
        $("#help").text("Help?");
    });

    $(".common").click(function (e) {
        $(".help-sub").slideToggle("slow");
        $("body").removeClass("stopscroll");
        $(".overlay-help").removeClass("show");
        $("#help").text("Help?");
    });
});

// sticky header
$(window).scroll(function () {
    var num = $(".header-container").outerHeight();
    var screenWidth = $(window).width();

    if ($(this).scrollTop() > num && screenWidth >= 768) {
        $(".header").addClass("sticky");
    } else {
        $(".header").removeClass("sticky");
    }
});

// add padding

function adjustPadding() {
    if ($(window).width() > 1199) {
        var hederHeight = $(".header-container .header").outerHeight();
        $(".section-wrapper").css("padding-top", hederHeight);
    } else {
        $(".section-wrapper").css("padding-top", 85);
    }
}

adjustPadding();

// Re-check on window resize

let resizePadding;
$(window).resize(function () {
    clearTimeout(resizePadding);
    resizePadding = setTimeout(adjustPadding, 1000);
});
